import styled, { css } from 'styled-components';

const ANIMATION_TIME = 300;
const BlanketArea = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: rgba(224, 224, 224, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: ${ANIMATION_TIME}ms ease;

  ${({ isAnimatin }) => isAnimatin && css``}

  ${({ isClosing, isAnimatin }) => isClosing && isAnimatin && css``}

    ${({ isTransparent }) =>
    isTransparent &&
    css`
      background: transparent;
      display: none;
    `}

    ${({ isTransparentBlanket }) =>
    isTransparentBlanket &&
    css`
      background: transparent;
    `}

     

  ${({ cssExt }) => cssExt && cssExt}
`;

export default function Blanket({ children, cssExt, onClick, isShow, isAnimatin, isTransparent, isTransparentBlanket }) {
  return (
    <BlanketArea
      show={isShow}
      cssExt={cssExt}
      onClick={onClick}
      isClosing={isShow}
      isAnimatin={isAnimatin}
      isTransparent={isTransparent}
      isTransparentBlanket={isTransparentBlanket}>
      {children}
    </BlanketArea>
  );
}
